module.exports = new Promise(resolve => {
          const remoteUrl = window.remoteConfig && window.remoteConfig.campaignUIRemoteUrl;
          if (!remoteUrl) {
            console.error('[federation] campaignUIRemoteUrl not configured on window.remoteConfig');
            return resolve(null);
          }
          const script = document.createElement('script');
          script.src = remoteUrl;
          script.type = 'text/javascript';
          script.async = true;
          script.onload = () => {
            const proxy = {
              get: (request) => window.CampaignUI.get(request),
              init: (arg) => {
                try {
                  return window.CampaignUI.init(arg);
                } catch (e) {
                  console.log('[federation] CampaignUI container already initialized');
                }
              }
            };
            resolve(proxy);
          };
          script.onerror = (err) => {
            console.error('[federation] failed to load remoteEntry.js from', remoteUrl, err);
            resolve(null);
          };
          document.head.appendChild(script);
        });